import styled from 'styled-components';

/**
 * Tons dos badges nos dois temas.
 *
 * Não dá para usar direto os tokens de cor do tema (successColor, warningColor)
 * como fundo: no escuro eles são escuros demais e o texto some. Aqui cada tom
 * tem o par fundo/texto próprio para claro e escuro.
 */
const tons = {
  ok: { claro: ['#dcfce7', '#166534'], escuro: ['#1e3a2a', '#7ee2a8'] },
  alerta: { claro: ['#fef3c7', '#92400e'], escuro: ['#4a3410', '#fbbf24'] },
  neutro: { claro: ['#e5e7eb', '#374151'], escuro: ['#3c3c3c', '#cbd5e0'] },
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Aviso = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.gray};
`;

export const ErrorMessage = styled.div`
  background-color: ${({ theme }) => theme.dangerLightColor};
  color: ${({ theme }) => (theme.isDark ? '#ffb4b4' : '#b91c1c')};
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 14px;
  font-size: 14px;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.primaryColor};
  color: #fff;

  &:hover {
    background-color: ${({ theme }) => theme.primaryColorHover};
  }
`;

export const TableButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-right: 6px;
  border: 1px solid ${({ theme }) => theme.borderColor};
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.lightColor};
  color: ${({ theme }) => theme.iconColor};

  &:hover {
    background-color: ${({ theme }) => theme.lightGrayHover};
    color: ${({ theme }) => theme.textColor};
  }
`;

export const Badge = styled.span<{ $tom?: 'ok' | 'alerta' | 'neutro' }>`
  display: inline-block;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  background-color: ${({ theme, $tom }) =>
    tons[$tom || 'neutro'][theme.isDark ? 'escuro' : 'claro'][0]};
  color: ${({ theme, $tom }) =>
    tons[$tom || 'neutro'][theme.isDark ? 'escuro' : 'claro'][1]};
`;

export const Mono = styled.span`
  font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
  font-size: 12px;
  color: ${({ theme }) => theme.textColor};
`;
